import { Component, OnInit } from '@angular/core';
import * as moment from 'moment';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { API as API_KEYS,CONST_AWS_API, DEFAULT_IMAGE } from 'src/app/core/constants';
import { environment } from 'src/environments/environment';
import { API } from 'aws-amplify';
import { UserService } from 'src/app/core/services/user.service';
import { Subscription } from 'rxjs';
import { CommanSubscribeService } from 'src/app/core/services/comman-subscribe.service';
import { Router } from '@angular/router';
import ConnectToStarzWallet from 'web3modal/dist/providers/connectors/starzwallet';
import { AppService } from 'src/app/core/services/app.service';
import { groupTeamsByNetwork, filterTeamGroups, GroupedTeams } from 'src/app/core/utils/team-grouping.util';

// Was DateRangeFilterComponent's public API - folded in here since the date range filter is
// only ever used on this one screen, so a separate reusable component added indirection with
// no reuse to show for it.
export interface DateRangePreset {
  label: string;
  months: number;
}

export interface DateRangeFilterValue {
  label: string;
  months: number;
  startDate: Date;
  endDate: Date;
}

@Component({
  selector: 'app-event-marketplace',
  templateUrl: './event-marketplace.component.html',
  styleUrls: ['./event-marketplace.component.scss']
})
export class EventMarketplaceComponent implements OnInit {
  bannerList: any[] = []
  // Starts true - no fetch has happened yet, so the template must not read an empty bannerList
  // as "genuinely no data" before getEvents() has even had a chance to run.
  isLoadingEvent: boolean = true;
  eventsLoadError: boolean = false;
  eventList: any = {};
  timezoneVal;
  myListResp: any;
  myListInfoSubscription: Subscription;
  userInfoSubscription: Subscription;
  searchfil: any;
  userInfo: any = {};
  myList: any = [];
  FilterDrop = ['Live', 'Upcoming'];
  SortDrop = [{
    name: 'Event Name (A-Z)',
    value: "a-z"
  }, {
    name: 'Event Name (Z-A)',
    value: "z-a"
  }, {
    name: 'Event Date (Ascending)',
    value: "latest"
  }, {
    name: 'Event Date (Descending)',
    value: "oldest"
  }];
  dumarray = []
  settingsData: any = {};
  settingsDataSubscription: Subscription;
  performerSubscriptionInfo: any = {};
  performerInfoSubscription: Subscription;
  org_id: any;
  // In-flight guard, not a once-only flag - getEvents() re-fetches on every date range change,
  // so this only blocks a second call while one is already outstanding (e.g. ngOnInit's two
  // getPerformerSubscriptionInfo() paths racing on first load).
  private eventsLoaded = false;
  private recommendationsPosted = false;

  groupsList: any[] = [];
  groupsLabel = 'Group';
  allDivisions: any[] = [];
  allSports: any[] = [];
  teamsList: any[] = [];
  teamsNetworkLabel = '';
  homeGroupGroups: GroupedTeams = { networkLabel: '', networkTeams: [], groupedTeams: [] };
  awayGroupGroups: GroupedTeams = { networkLabel: '', networkTeams: [], groupedTeams: [] };

  selectedGroup: any = null;
  selectedGroupName = '';
  selectedHomeTeam: any = null;
  selectedHomeTeamName = '';
  selectedAwayTeam: any = null;
  selectedAwayTeamName = '';
  selectedDivision: any = null;
  selectedDivisionName = '';
  selectedSport: any = null;
  selectedSportName = '';
  // Defaults to "Next 3 Months" on load (same shape/math as DateRangeFilterComponent.selectPreset)
  // rather than "Any Time" — set directly, not via onDateRangeChange(), so it doesn't call
  // applyFilters() before getEvents()'s async data has populated dumarray (see
  // applyActiveGroupDefault() above for the same pattern).
  selectedDateRange: DateRangeFilterValue | null = {
    label: 'Next 3 Months',
    months: 3,
    startDate: moment().startOf('day').toDate(),
    endDate: moment().startOf('day').add(3, 'months').endOf('day').toDate()
  };
  selectedDateRangeLabel = this.selectedDateRange.label;

  readonly dateRangePresets: DateRangePreset[] = [
    { label: '3 Months', months: 3 },
    { label: '6 Months', months: 6 },
    { label: '1 Year', months: 12 }
  ];

  // Tracks the in-progress calendar selection separately from `selectedDateRange` - a range pick
  // fires matStartDate's dateChange first, then matEndDate's; buffering both here (instead of
  // reading `selectedDateRange` on the second event) means the just-picked start isn't lost
  // before the end is picked. Seeded from the initial default above so a first manual pick
  // starts from the same window the presets would (mirrors the old component's ngOnChanges).
  private pendingDateRangeStart: Date | null = this.selectedDateRange.startDate;
  private pendingDateRangeEnd: Date | null = this.selectedDateRange.endDate;

  groupSearchText = '';
  homeTeamSearchText = '';
  awayTeamSearchText = '';

  // Collapsed by default - only the search bar + quick chips (Live & Upcoming / Next 3 Months)
  // show on load; the "Filters" toggle button expands the Sort/Group/Team/Division/Sport +
  // date range row below.
  showFilterPanel = false;

  // Passed as [displayFn] to the shared FilterDropdownComponent - each field keeps its own
  // label-extraction rule (group/team/division/sport payload shapes differ) without the
  // presentational component needing to know about any of them.
  groupDisplayFn = (g: any) => g?.group_name || g?.name || '';
  teamDisplayFn = (t: any) => t?.name || '';
  divisionDisplayFn = (d: any) => d?.category_name || d?.name || '';
  sportDisplayFn = (s: any) => s?.sport_name || s?.name || '';

  constructor(private ngxLoader: NgxUiLoaderService, private appTVService: AppService,private userService: UserService, private commanService: CommanSubscribeService, public router: Router, private commonSubscribeService: CommanSubscribeService) { }

  ngOnInit() {
    this.timezoneVal = this.userService.getTimezone();
    this.userInfo = this.commanService.userInfo;
    this.userInfoSubscription = this.commanService.getUserInfo().subscribe(response => {
      this.userInfo = response;
      this.getList()
    });
    
    console.log(this.userInfo, "userinfo")
    if (this.userInfo.id) {
      this.getList();
    }
    if(!this.router.url.includes('/network-market/event')){
      this.settingsDataSubscription = this.commanService.getICWebpageThemeSettings().subscribe(async (response) => {
        this.settingsData = response;
      });
      this.settingsData = this.commanService.icWebpageSettingsData;
    } else {
      this.settingsData = this.commanService.icWebpageSettingsData;
    }

    this.performerInfoSubscription = this.commanService.getPerfomerInfo().subscribe(response => {
      this.getPerformerSubscriptionInfo(response);
    });
    const cachedPerformerInfo = this.commanService.perfomerInfoData;
    if (cachedPerformerInfo && Object.keys(cachedPerformerInfo).length > 0) {
      this.getPerformerSubscriptionInfo(cachedPerformerInfo);
    }

    // this.postRecommandations();
  }

  getPerformerSubscriptionInfo(response: any) {
    if (response && response.data && response.data.statusCode === '200') {
      this.performerSubscriptionInfo = response;
      this.org_id = response.data.Data?.[0]?.organization_id ?? null;
      this.groupsList = response.data.Data?.[0]?.groups || [];
      this.groupsLabel = response.data.Data?.[0]?.network_type_label || 'Group';
      this.allDivisions = response.data.Data?.[0]?.categories || [];
      this.allSports = response.data.Data?.[0]?.sports || [];
      this.teamsNetworkLabel = response.data.Data?.[0]?.channel_display_name || '';
      this.getTeamsList();
      this.applyActiveGroupDefault();
      // this.postRecommandations();
    }
    this.getEvents();
  }

  // When browsing at a group-scoped URL, default the group filter to the active group so
  // Division/Sport/Home Team/Away Team narrow immediately, without the user re-picking the
  // group they're already viewing. Sets state directly (not via selectGroup()) so it doesn't
  // call applyFilters() before getEvents()'s async data has populated dumarray.
  private applyActiveGroupDefault() {
    if (this.selectedGroup || !this.commanService.activeGroupId) return;
    const activeGroup = (this.groupsList || []).find((g: any) => Number(g.id) === Number(this.commanService.activeGroupId));
    if (!activeGroup) return;
    this.selectedGroup = activeGroup.id;
    this.selectedGroupName = activeGroup.group_name || activeGroup.name;
  }

  // Home/Away Team options are sourced from the teams API (league/team/all), same as
  // partner-ui's create-event flow, instead of reusing the network "groups" list.
  getTeamsList() {
    const organizationId = this.org_id ?? this.settingsData?.organization_id;
    if (!organizationId) return;
    this.appTVService.postBaseRequest(API_KEYS.GET_TEAMS, { organizationId }).subscribe((result: any) => {
      this.teamsList = ((result && result.data) || []).filter((team: any) => team.dataStatus === 'A');
      this.refreshHomeGroupGroups(this.selectedAwayTeam);
      this.refreshAwayGroupGroups(this.selectedHomeTeam);
    }, (error) => {
      console.error('Error loading teams:', error);
      this.teamsList = [];
    });
  }

  // Mirrors partner-ui's create-event-flow.component.ts refreshHomeGroupGroups/refreshAwayGroupGroups:
  // cached fields refreshed explicitly on selection, instead of live getters re-evaluated on every
  // change-detection tick - the pattern confirmed working there for this exact mutual-exclusion behavior.
  // Not filtered by selectedGroup - Home/Away Team options and selections are independent of
  // the Group filter; only Division and Sport narrow when the group changes (see selectGroup()).
  refreshHomeGroupGroups(excludeTeamId?: any) {
    const teams = (this.teamsList || []).filter((t: any) => !this.isExcludedTeam(t, excludeTeamId));
    const grouped = groupTeamsByNetwork(teams, this.groupsList, this.teamsNetworkLabel);
    this.homeGroupGroups = filterTeamGroups(grouped, this.homeTeamSearchText);
  }

  refreshAwayGroupGroups(excludeTeamId?: any) {
    const teams = (this.teamsList || []).filter((t: any) => !this.isExcludedTeam(t, excludeTeamId));
    const grouped = groupTeamsByNetwork(teams, this.groupsList, this.teamsNetworkLabel);
    this.awayGroupGroups = filterTeamGroups(grouped, this.awayTeamSearchText);
  }

  // A group's categories_sports (e.g. [{category_id: 79, sport_ids: [35,44]}]) scopes which
  // divisions/sports belong to it - same restriction pattern as ai-agent.component.ts's
  // getAllowedCategorySportsForSelectedGroups, single-group since only one group filter here.
  private getAllowedDivisionSportsForGroup(groupId: any): { divisionIds: Set<number>; sportIdsByDivision: Map<number, Set<number>> } | null {
    if (!groupId) return null;
    const group = (this.groupsList || []).find((g: any) => Number(g.id) === Number(groupId));
    const divisionIds = new Set<number>();
    const sportIdsByDivision = new Map<number, Set<number>>();
    (group?.categories_sports || []).forEach((entry: any) => {
      const divisionId = Number(entry.category_id);
      divisionIds.add(divisionId);
      const sportIds = sportIdsByDivision.get(divisionId) || new Set<number>();
      (entry.sport_ids || []).forEach((sportId: any) => sportIds.add(Number(sportId)));
      sportIdsByDivision.set(divisionId, sportIds);
    });
    return { divisionIds, sportIdsByDivision };
  }

  // Teams can be registered per network-group, so the same real-world team (e.g. "Koli") can
  // appear as multiple rows sharing a name but not an id - excluding only by id left a
  // same-named row selectable in the other dropdown, so this also excludes by name.
  private isExcludedTeam(candidate: any, excludedId: any): boolean {
    if (excludedId === null || excludedId === undefined || excludedId === '') return false;
    if (this.isSameTeamId(candidate.id, excludedId)) return true;
    const excluded = (this.teamsList || []).find((t: any) => this.isSameTeamId(t.id, excludedId));
    return !!excluded && !!candidate.name && !!excluded.name
      && candidate.name.trim().toLowerCase() === excluded.name.trim().toLowerCase();
  }

  // Team ids from the teams API (league/team/all) aren't guaranteed to be numeric - Number()
  // silently turns two non-numeric-but-equal ids into NaN === NaN (always false), which is why
  // the exclusion above could fail to match even the exact same team. Compare as strings first.
  private isSameTeamId(a: any, b: any): boolean {
    if (a === null || a === undefined || b === null || b === undefined) return false;
    return String(a) === String(b);
  }

  get activeFilterCount(): number {
    const groupNameIfVisible = this.isGroupScoped ? '' : this.selectedGroupName;
    const optionalActive = [groupNameIfVisible, this.selectedHomeTeamName, this.selectedAwayTeamName, this.selectedDivisionName, this.selectedSportName, this.selectedDateRangeLabel]
      .filter((v) => !!v).length;
    return 1 + optionalActive; // Event Type always counts - it always resolves to a value (default "Live & Upcoming" or an explicit pick).
  }

  get hasActiveFilters(): boolean {
    const groupNameIfVisible = this.isGroupScoped ? '' : this.selectedGroupName;
    return !!(this.filterValue || groupNameIfVisible || this.selectedHomeTeamName || this.selectedAwayTeamName || this.selectedDivisionName || this.selectedSportName || this.selectedDateRangeLabel);
  }

  // Group is already implied by the URL when browsing a group-scoped page, so the Group
  // filter (dropdown + chip) is redundant and hidden in that case.
  get isGroupScoped(): boolean {
    return !!this.commanService.activeGroupId;
  }

  get divisionOptions(): any[] {
    const allowed = this.getAllowedDivisionSportsForGroup(this.selectedGroup);
    if (!allowed) return this.allDivisions;
    return (this.allDivisions || []).filter((d: any) => allowed.divisionIds.has(Number(d.category_id ?? d.id)));
  }

  get sportOptions(): any[] {
    const allowed = this.getAllowedDivisionSportsForGroup(this.selectedGroup);
    if (!allowed) return this.allSports;
    if (this.selectedDivision) {
      const sportIds = allowed.sportIdsByDivision.get(Number(this.selectedDivision));
      return (this.allSports || []).filter((s: any) => sportIds ? sportIds.has(Number(s.sport_id ?? s.id)) : false);
    }
    const allowedSportIds = new Set<number>();
    allowed.sportIdsByDivision.forEach(set => set.forEach(id => allowedSportIds.add(id)));
    return (this.allSports || []).filter((s: any) => allowedSportIds.has(Number(s.sport_id ?? s.id)));
  }

  selectGroup(group: any) {
    this.selectedGroup = group ? group.id : null;
    this.selectedGroupName = group ? (group.group_name || group.name) : '';
    this.selectedDivision = null;
    this.selectedDivisionName = '';
    this.selectedSport = null;
    this.selectedSportName = '';
    this.groupSearchText = '';
    this.applyFilters();
  }

  private getTeamNetworkGroupName(team: any): string {
    if (!team || !team.networkGroupId) return '';
    const group = (this.groupsList || []).find((g: any) => g.id == team.networkGroupId);
    return group ? (group.network_group_name || group.group_name || group.name) : '';
  }

  // Mirrors the previous (ngModelChange) handlers on the inline Home/Away Team search inputs -
  // moved here since the search box now lives inside the shared FilterDropdownComponent.
  onHomeTeamSearchTextChange(value: string) {
    this.homeTeamSearchText = value;
    this.refreshHomeGroupGroups(this.selectedAwayTeam);
  }

  onAwayTeamSearchTextChange(value: string) {
    this.awayTeamSearchText = value;
    this.refreshAwayGroupGroups(this.selectedHomeTeam);
  }

  selectHomeTeam(team: any) {
    this.selectedHomeTeam = team ? team.id : null;
    const networkGroupName = this.getTeamNetworkGroupName(team);
    this.selectedHomeTeamName = team ? (networkGroupName ? `${team.name} (${networkGroupName})` : team.name) : '';
    this.homeTeamSearchText = '';
    this.refreshAwayGroupGroups(this.selectedHomeTeam);
    this.applyFilters();
  }

  selectAwayTeam(team: any) {
    this.selectedAwayTeam = team ? team.id : null;
    const networkGroupName = this.getTeamNetworkGroupName(team);
    this.selectedAwayTeamName = team ? (networkGroupName ? `${team.name} (${networkGroupName})` : team.name) : '';
    this.awayTeamSearchText = '';
    this.refreshHomeGroupGroups(this.selectedAwayTeam);
    this.applyFilters();
  }

  selectDivision(division: any) {
    this.selectedDivision = division ? (division.category_id ?? division.id) : null;
    this.selectedDivisionName = division ? (division.category_name ?? division.name) : '';
    if (this.selectedSport !== null && !this.sportOptions.some((s: any) => Number(s.sport_id ?? s.id) === Number(this.selectedSport))) {
      this.selectedSport = null;
      this.selectedSportName = '';
    }
    this.applyFilters();
  }

  selectSport(sport: any) {
    this.selectedSport = sport ? (sport.sport_id ?? sport.id) : null;
    this.selectedSportName = sport ? (sport.sport_name ?? sport.name) : '';
    this.applyFilters();
  }

  // org_publish_date_time's format differs by event type: upcoming events use 'MMM DD YYYY'
  // (set in getEvents()'s single_session_event/else branches), while live events inherit
  // publish_date_time's 'DD MMM YYYY[, hh:mm A]' (set just above the live-events loop) - a single
  // format string can't parse both, so every known format is tried.
  private parseOrgPublishDate(value: string): moment.Moment | null {
    if (!value) return null;
    const parsed = moment(value, ['MMM DD YYYY', 'DD MMM YYYY, hh:mm A', 'DD MMM YYYY'], true);
    return parsed.isValid() ? parsed : null;
  }

  // sortData()'s latest/oldest branches previously sorted on event_start_date_time, a field
  // never set anywhere on the banner items - Date.parse(undefined) is NaN, so the comparator
  // always returned NaN and the sort was a no-op. org_publish_date_time is the field actually
  // populated (see getEvents()/applyFilters() above), parsed via the same helper as the date
  // range filter.
  private orgPublishDateValue(item: any): number {
    const parsed = this.parseOrgPublishDate(item?.org_publish_date_time);
    return parsed ? parsed.valueOf() : 0;
  }

  // Dedupes by title+date first, not id - that's what makes two cards look like the same event
  // on screen, and the upcoming/live merge in getEvents() can leave two copies of the same event
  // under different ids (e.g. a live-session id distinct from the event id). Falls back to id
  // only when there's no title to compare.
  private dedupeBanners(banners: any[]): any[] {
    const seen = new Set<string>();
    return (banners || []).filter((banner: any) => {
      const key = banner.stream_video_title ? `td:${banner.stream_video_title}|${banner.org_publish_date_time}` : `id:${banner.id}`;
      if (seen.has(key)) return false;
      seen.add(key);
      return true;
    });
  }

  // Used when rebuilding categoryList in getEvents() so a category's highlighted (catOn) state
  // survives a refetch triggered by any other filter (date range, group, etc.) - categoryList is
  // rebuilt from scratch on every fetch, so without checking this, every rebuilt entry defaulted
  // to unselected even while selectedCat itself (and the actual filtering) was untouched.
  private isCategorySelected(categoryName: string): boolean {
    return !!this.selectedCat && !!categoryName && categoryName.toLowerCase() === this.selectedCat.toLowerCase();
  }

  // MercheMarketplaceModule registers MatMomentDateModule, so the datepicker's DateAdapter
  // works in `moment.Moment`, not native `Date` - every value crossing into/out of the
  // <mat-date-range-input> below is converted at this boundary; DateRangeFilterValue itself
  // stays native Date, matching applyFilters()'s existing contract.
  //
  // Bound to the pending (in-progress) values, not the committed selectedDateRange - the
  // committed range only updates once both start and end are picked (tryEmitManualDateRange),
  // so binding [value] to it meant every change-detection cycle after the first click reset
  // the input back to the old committed start date, reverting the click before the fan could
  // pick an end date. pendingDateRangeStart/End update immediately on each click instead.
  get dateRangePickerStart(): moment.Moment | null {
    return this.pendingDateRangeStart ? moment(this.pendingDateRangeStart) : null;
  }

  get dateRangePickerEnd(): moment.Moment | null {
    return this.pendingDateRangeEnd ? moment(this.pendingDateRangeEnd) : null;
  }

  // Bound to today/today+1yr always, not the active preset's own window - binding these to
  // selectedDateRange.startDate/endDate meant the calendar only allowed picking within
  // whatever preset was currently active (e.g. 3 months on load), disabling every other date
  // and making the picker unusable for picking outside that narrow window.
  get dateRangeMinDate(): moment.Moment {
    return moment().startOf('day');
  }

  get dateRangeMaxDate(): moment.Moment {
    return moment().startOf('day').add(Math.max(...this.dateRangePresets.map(p => p.months)), 'months');
  }

  // Plain formatted strings for the visible pill display - tracks the same pending (in-progress)
  // values as dateRangePickerStart/End above, so the visible text updates immediately on each
  // click, before a two-click manual range completes. Separate from those getters since this
  // is for the <mat-form-field>-free display, not the hidden Material inputs' [value] binding.
  get dateRangeDisplayStart(): string {
    return this.pendingDateRangeStart ? moment(this.pendingDateRangeStart).format('M/D/YYYY') : 'Start';
  }

  get dateRangeDisplayEnd(): string {
    return this.pendingDateRangeEnd ? moment(this.pendingDateRangeEnd).format('M/D/YYYY') : 'End';
  }

  isDateRangeActive(preset: DateRangePreset): boolean {
    return this.selectedDateRange?.months === preset.months;
  }

  selectDateRangePreset(preset: DateRangePreset) {
    const startDate = moment().startOf('day').toDate();
    const endDate = moment().startOf('day').add(preset.months, 'months').endOf('day').toDate();
    this.onDateRangeChange({ label: `Next ${preset.label}`, months: preset.months, startDate, endDate });
  }

  // Lets the fan pick any date from the calendar itself, not just within the active preset's
  // window; the picker's own [min]/[max] (fixed at today/today+1yr) is the only bound applied.
  // $event.value is a moment.Moment (MatMomentDateModule) - converted back to native Date here.
  onDateRangeStartChange(momentValue: moment.Moment | null) {
    this.pendingDateRangeStart = momentValue ? momentValue.startOf('day').toDate() : null;
    // A fresh start pick begins a new range - clear the previous range's leftover end date so
    // tryEmitManualDateRange() waits for the matching end pick instead of immediately emitting
    // (and filtering/re-fetching) using the stale end still buffered from before this click.
    this.pendingDateRangeEnd = null;
    this.tryEmitManualDateRange();
  }

  onDateRangeEndChange(momentValue: moment.Moment | null) {
    // endOf('day'), not the picked moment as-is - a date pick resolves to midnight (start of
    // that day), so using it directly as the end boundary excluded every event later that same
    // day (e.g. picking "Aug 28" as the end cut off anything published after Aug 28 00:00:00).
    this.pendingDateRangeEnd = momentValue ? momentValue.endOf('day').toDate() : null;
    this.tryEmitManualDateRange();
  }

  private tryEmitManualDateRange() {
    if (!this.pendingDateRangeStart || !this.pendingDateRangeEnd) return;
    // Not this.selectedDateRange.label/months - reusing the previously-active preset's values
    // left the just-replaced preset button highlighted (isDateRangeActive matches on months)
    // and the filter chip still reading e.g. "Next 6 Months" after a manual pick replaced it.
    // months: 0 is a sentinel no real preset (3/6/12) ever has, so no button stays active.
    this.onDateRangeChange({
      label: 'Custom Range',
      months: 0,
      startDate: this.pendingDateRangeStart,
      endDate: this.pendingDateRangeEnd
    });
  }

  onDateRangeChange(range: DateRangeFilterValue | null) {
    this.selectedDateRange = range;
    this.selectedDateRangeLabel = range ? range.label : '';
    this.pendingDateRangeStart = range?.startDate ?? null;
    this.pendingDateRangeEnd = range?.endDate ?? null;
    // A selected range (preset or manual pick) re-queries the API for that window instead of
    // just re-filtering whatever was already fetched - getEvents()'s success handler calls
    // applyFilters() once the new results are in, so group/team/sport/division filters still
    // apply on top. Clearing the range (null) has nothing to re-fetch by, so just re-filter.
    if (range) {
      this.getEvents({ startDate: range.startDate, endDate: range.endDate });
    } else {
      this.applyFilters();
    }
  }

  resetAllFilters() {
    this.searchfil = '';
    this.filterData('');
    this.selectGroup(null);
    this.selectHomeTeam(null);
    this.selectAwayTeam(null);
    this.selectDivision(null);
    this.selectSport(null);
    // Restores the "Next 3 Months" default instead of clearing the date range entirely -
    // onDateRangeChange(null) would drop the default window the page loads with (see
    // selectedDateRange's initializer above). Does NOT force-clear eventsLoaded here - that
    // guard exists to stop two overlapping getEvents() fetches from both pushing into the same
    // bannerList/categoryList (each fetch only resets those arrays once, synchronously, right
    // before it starts) - bypassing it let a still-in-flight fetch (e.g. from a preset just
    // clicked) race the Reset-triggered one and land duplicate entries in bannerList.
    this.selectDateRangePreset(this.dateRangePresets[0]);
    // catFilter() sets selectedCat/selectedCatIndex and each category's catOn flag but never
    // unsets them elsewhere - without this, the category buttons stayed highlighted and
    // applyFilters() kept filtering by the old category after Reset.
    this.selectedCat = '';
    this.selectedCatIndex = '';
    this.categoryList.forEach((cat: any) => cat.catOn = false);
    // catFilter() also reads banner.catOn (on dumarray items) to decide whether the next click
    // toggles a category on or off - leaving these stale would make the next click on the same
    // category silently toggle it off instead of on.
    (this.dumarray || []).forEach((banner: any) => banner.catOn = false);
    this.applyFilters();
  }

  applyFilters() {
    let list = this.dumarray || [];
    if (this.selectedCat && this.selectedCatIndex !== '' && this.selectedCatIndex >= 0) {
      list = list.filter((arr: any) => arr.category_name == this.selectedCat);
    }
    if (this.filterValue) {
      list = list.filter((arr: any) => this.filterValue.toLowerCase() == 'upcoming' ? arr.inUpcoming == 1 : arr.inLive == 1);
    }
    if (this.selectedGroup) {
      list = list.filter((arr: any) => Number(arr.network_group_id) === Number(this.selectedGroup));
    }
    if (this.selectedHomeTeam) {
      list = list.filter((arr: any) => this.isSameTeamId(arr.home_team_id, this.selectedHomeTeam));
    }
    if (this.selectedAwayTeam) {
      list = list.filter((arr: any) => this.isSameTeamId(arr.away_team_id, this.selectedAwayTeam));
    }
    if (this.selectedDivision) {
      list = list.filter((arr: any) => Number(arr.network_group_category_id) === Number(this.selectedDivision));
    }
    if (this.selectedSport) {
      list = list.filter((arr: any) => Number(arr.network_sport_id) === Number(this.selectedSport));
    }
    if (this.selectedDateRange) {
      const { startDate, endDate } = this.selectedDateRange;
      list = list.filter((arr: any) => {
        const parsed = this.parseOrgPublishDate(arr.org_publish_date_time);
        return !!parsed && parsed.toDate() >= startDate && parsed.toDate() <= endDate;
      });
    }
    this.bannerList = list;
    if (this.sortEvent && Object.keys(this.sortEvent).length > 0) {
      this.sortData(this.sortEvent);
    }
  }

postRecommandations() {
  if (this.recommendationsPosted) return;
  this.recommendationsPosted = true;
  if (this.router.url.includes('/preview')) return;
  try {
    if (!this.userInfo?.id || !this.org_id) {
      console.warn(
        '[Event Marketplace][Recommendations] Missing required data:',
        {
          userId: this.userInfo?.id,
          organizationId: this.commanService?.orgId
        }
      );
      return;
    }

    const formData = new FormData();
    formData.append('user_id', this.userInfo.id.toString());
    formData.append('organization_id', this.org_id.toString());
    formData.append('recommendation_type', 'events');
    formData.append('top_k', '40');
    if (this.commanService.activeGroupId) {
      formData.append('network_group_id', this.commanService.activeGroupId.toString());
    }
    const url = `${API_KEYS.AI_RECOMMENDATION}?NOLOADER`;
    this.appTVService.postBaseRequest(url, formData).subscribe(
      (result) => {
        console.info(
          '[Event Marketplace][Recommendations] API response received',
          result
        );

        if (result?.statusCode === 200) {
          // console.log(
          //   '[Event Marketplace][Recommendations] Recommendation success',
          //   result
          // );
        } 
      },
      (error) => {
        console.error(
          '[Event Marketplace][Recommendations] API request failed',
          {
            error,
            userId: this.userInfo.id,
            organizationId: this.commanService.orgId
          }
        );
      }
    );
  } catch (error) {
    console.error(
      '[Event Marketplace][Recommendations] Unexpected client-side error',
      error
    );
  }
}


  getList() {
    let myInit = {
      headers: {
        "Content-Type": "application/json",
        "x-api-key": environment.AWS_Cognito.X_Api_Key,
        "Authorization": `Bearer ${this.userInfo.access_token}`
      },
      response: true,
      body: { userid: this.userInfo.id }
    }

    this.ngxLoader.start();
    // this.isLoadingList = true;
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.MY_LIST, myInit).then(response => {
      // this.isLoadingList = false;
      this.ngxLoader.stop();
      if (response.data.statusCode === '200' && response.data.Data) {
        console.log(response.data.Data)
        // this.commanService.initSlider(".channels-images-slider3");
        response.data.Data.forEach(e => {
          e.image = e.video_banner_image ? e.video_banner_image : e.video_thumbnail_image;
          // if (!e.image) {
          //   e.image = DEFAULT_IMAGE.IMAGE_1;
          // }
          this.myList.unshift(e);
          this.commanService.sendMylistData(this.myList);
          if (this.myList.length > 0 && this.bannerList.length > 0) {
            this.myList.forEach(list => {
              this.bannerList.forEach(event => {
                if (Number(event.id) == Number(list.stream_video_id)) {
                  event.isTicketPurchased = true;
                  event.ticket_key = list.ticket_key;
                }
              });
            });
          }
        })
        // this.isAPICalled = true;
      }
    }).catch(error => {
      // this.isLoadingList = false;
      this.ngxLoader.stop();
    });
  }
  // dateRange defaults to selectedDateRange (Next 3 Months on first load) - preset clicks and
  // manual date picks re-call this with their own range via onDateRangeChange() so the API is
  // re-queried for that window rather than filtering whatever was fetched for a narrower one.
  getEvents(dateRange?: { startDate: Date, endDate: Date }) {
    if (this.eventsLoaded) return;
    this.eventsLoaded = true;
    // Marks a fetch as in-flight so the template shows the loading state instead of "No Data
    // Available" - covers both the initial load and a re-fetch triggered by a date range change.
    this.isLoadingEvent = true;
    this.eventsLoadError = false;
    const activeRange = dateRange ?? {
      startDate: this.selectedDateRange?.startDate ?? moment().startOf('day').toDate(),
      endDate: this.selectedDateRange?.endDate ?? moment().startOf('day').add(3, 'months').endOf('day').toDate()
    };
    let myInit = {
      headers: {
        'x-api-key': environment.AWS_Cognito.X_Api_Key
      },
      response: true,
      body: {
        organization_id: this.org_id ?? this.settingsData.organization_id,
        start_date: activeRange.startDate,
        end_date: activeRange.endDate,
        ...(this.commanService.activeGroupId && { network_group_id: this.commanService.activeGroupId })
      }
    }
    // Reset before repopulating - bannerList/categoryList are built via push() below, so without
    // this a re-fetch (date range change, Reset) would duplicate every previously-fetched event
    // on top of the new results, and stale categories from a wider/different range (e.g.
    // "Tournament Events" only present in a 1-year fetch) would keep showing as filter pills
    // forever instead of reflecting only the categories present in the current results.
    this.bannerList = [];
    this.eventList.upcoming_events = [];
    this.categoryList = [];
    this.ngxLoader.start();
    API.post(environment.AWS_Cognito.apiName, CONST_AWS_API.EVENTS, myInit).then(response => {

      if (response.data.statusCode === '200' && response.data.Data) {
        this.commanService.initSlider(".channels-images-slider1");
        this.eventList = response.data.Data;
        // this.channelarray = this.eventList.channels;
        //  this.channelarray = [this.eventList.channels[0]];
        this.commanService.sendUpcomingEvents(this.eventList.upcoming_events);
        if (this.eventList.upcoming_events && this.eventList.upcoming_events.length > 0) {
          this.eventList.upcoming_events.forEach(e => {
            if (e.Category_info.category_name) {
              e.stream_info.category_name = e.Category_info.category_name;
              let new_ar = this.categoryList.filter(a => a.name.toLowerCase() == e.Category_info.category_name.toLowerCase());
              if (new_ar.length == 0) {
                // Preserves the active selection across a refetch triggered by any OTHER filter
                // (date range, group, etc.) - categoryList is rebuilt from scratch on every fetch
                // (see the reset above), so without this, changing e.g. the date range while a
                // category was selected silently dropped that category's highlighted state, even
                // though selectedCat itself (and so the actual filtering) was untouched.
                let l = { 'name': e.Category_info.category_name, 'catOn': this.isCategorySelected(e.Category_info.category_name) };
                this.categoryList.push(l);
              }
            }
            e = e.stream_info;
            if (e.selected_type == "recurring_event" && e.recurring_type == 'weekly') {
              let recurring_dates = JSON.parse(e.event_dates_json)
              console.log(recurring_dates, ">>>>>dates", typeof recurring_dates);
              let days = [];
              Object.keys(recurring_dates).forEach((rec: any) => {
                console.log(rec);
                let newday = days.filter(a => a == recurring_dates[rec].day);
                if (newday.length == 0) {
                  days.push(recurring_dates[rec].day);
                }
              })
              e.days = days.join(" , ");
              // console.log(days, e.days, "daysData>>>")
            }
            if (e.selected_type == "recurring_event" && e.recurring_type == 'custom') {
              let recurring_dates = JSON.parse(e.event_dates_json)
              console.log(recurring_dates, ">>>>>dates", typeof recurring_dates);
              let days = [];
              Object.keys(recurring_dates).forEach((rec: any) => {
                console.log(rec);
                let newday = days.filter(a => a == recurring_dates[rec].start);
                if (newday.length == 0) {
                  days.push(recurring_dates[rec].start);
                }
              })
              e.days_date = days;
              // e.days = days.join(" , ");
              // console.log(days, e.days, "daysData>>>")
            }
            e.name = e.user_first_name + ' ' + e.user_last_name;
            if (!e.video_thumbnail_image) {
              e.video_thumbnail_image = DEFAULT_IMAGE.IMAGE_1;
            }
            if (!e.video_banner_image) {
              e.video_banner_image = DEFAULT_IMAGE.IMAGE_2;
            }
            if (e.publish == 1) {
              e.org_publish_date_time = e.publish_date_time;
              let localTime = moment.utc(e.publish_date_time).toDate();
              let localTimeex = moment.utc(e.expected_end_date_time).toDate();
              if (e.selected_type == 'single_session_event') {
                e.org_publish_date_time = moment(localTime).format('MMM DD YYYY');
                e.org_expected_end_date_time = moment(localTimeex).format('MMM DD YYYY');
              }
              else {
                e.org_publish_date_time = moment(localTime).format('MMM DD YYYY');
                e.org_expected_end_date_time = moment(localTimeex).format('MMM DD YYYY');
                //e.publish_date_time = moment(e.publish_date_time).format("DD MMM YYYY hh:mm A");

              }
              e.isEvent = "upcoming";
              e.inUpcoming = 1;
              e.inLive = 0;
              if (!e.short_description) {
                e.short_description = "";
              }
              e.isBannerVideo = false;
              // e.banner_video_url = 'https://uploads-areveatv-dev.s3.us-west-2.amazonaws.com/banner-video/Copy-of-AREVEA_TV_JAS_TRAILER_LONGER-SPONSORED-40-secs-V3-4-5.mp4/1625670890664.mp4';

              if (e.media_files) {
                let media_files = JSON.parse(e.media_files);
                Object.keys(media_files).forEach(element => {
                  e[element] = media_files[element];
                });
              }
              this.bannerList.push(e);
            }
          });
          console.log(this.bannerList, "bannerList")
        }
        if (this.eventList.live_events && this.eventList.live_events.length > 0) {
          this.eventList.live_events.forEach(live => {
            this.eventList.upcoming_events.forEach(event => {
              if (live.stream_info.parent_streams_id == event.stream_info.id) {
                event.stream_info.inLive = 1;
                event.stream_info.inUpcoming = 0;
              }
              else {
                let new_data = this.eventList.upcoming_events.filter(li => li.stream_info.id == live.stream_info.parent_streams_id);
                // == (not ===), matching the two id comparisons above - ids arriving from the
                // upcoming vs live sections of this response aren't guaranteed to be the same
                // type, so a strict-equality check here could miss that this live event's own
                // record was already pushed to bannerList by the upcoming-events pass above, and
                // push a duplicate.
                let isInBannerList = this.bannerList.some(banner => banner.id == live.stream_info.id);
                if (new_data.length == 0 && !isInBannerList) {
                  let localTime = moment.utc(live.stream_info.publish_date_time).toDate();
                  if (live.stream_info.selected_type == 'single_session_event')
                    live.stream_info.publish_date_time = moment(localTime).format('DD MMM YYYY, hh:mm A');
                  else
                    live.stream_info.publish_date_time = moment(localTime).format('DD MMM YYYY');
                  //e.publish_date_time = moment(e.publish_date_time).format("DD MMM YYYY hh:mm A");
                  live.stream_info.org_publish_date_time = live.stream_info.publish_date_time;
                  live.stream_info.isEvent = "Live";
                  if (!live.stream_info.short_description) {
                    live.stream_info.short_description = "";
                  }
                  live.stream_info.isBannerVideo = false;
                  // e.banner_video_url = 'https://uploads-areveatv-dev.s3.us-west-2.amazonaws.com/banner-video/Copy-of-AREVEA_TV_JAS_TRAILER_LONGER-SPONSORED-40-secs-V3-4-5.mp4/1625670890664.mp4';

                  if (live.stream_info.media_files) {
                    let media_files = JSON.parse(live.stream_info.media_files);
                    Object.keys(media_files).forEach(element => {
                      live.stream_info[element] = media_files[element];
                    });
                  }
                  live.stream_info.inLive = 1;
                  live.stream_info.inUpcoming = 0;
                  this.bannerList.push(live.stream_info);
                }
              }
            })
          })
        }
        if (this.myListResp && this.myListResp.length > 0 && this.bannerList.length > 0) {
          this.myListResp.forEach(list => {
            this.bannerList.forEach(event => {
              if (Number(event.id) == Number(list.stream_video_id)) {
                event.isTicketPurchased = true;
                event.ticket_key = list.ticket_key;
              }
            });
          });
        }
        if (this.bannerList.length > 1) {
          // this.selectedIndex = 1;
        }
        if (this.eventList.channels && this.eventList.channels.length > 0) {
          this.eventList.channels.forEach(e => {
            e.name = e.performer_details.performer_display_name;
            e.logo = e.performer_details.performer_profile_pic ? e.performer_details.performer_profile_pic : DEFAULT_IMAGE.IMAGE_1;
            e.video_banner_image = e.performer_details.performer_profile_banner ? e.performer_details.performer_profile_banner : DEFAULT_IMAGE.IMAGE_2;
            e.isEvent = "channels";
            if (e.performer_details.performer_bio) {
              e.performer_bio = (e.performer_details.performer_bio.length > 150) ? e.performer_details.performer_bio.substring(0, 150) + "..." : e.performer_details.performer_bio;
            }
          });
        }
        if (this.eventList && this.eventList.festivals) {
          this.eventList.festivals.forEach(el => {
            if (el.stream_info.media_files) {
              let media_files = JSON.parse(el.stream_info.media_files);
              Object.keys(media_files).forEach(element => {
                el[element] = media_files[element];
              });
            }
            el.video_thumbnail_image = el.stream_info.video_thumbnail_image
            el.isEvent = 'festivals'
            el.event_home_banner = el.video_thumbnail_image
          });
        }
        // this.channelarray.forEach(element => {
        //   console.log("this.channelarray", this.channelarray);
        //   element.event_home_banner = element.org_info.channel_logo ? element.org_info.channel_logo : element.org_info.organization_logo;
        //   element.video_thumbnail_image = element.video_banner_image;
        //   element.channel_banner_img = element.org_info.channel_banner ? element.org_info.channel_banner : element.org_info.organization_logo;
        // });
        // this.selectedChannel = this.channelarray[0];
        this.ngxLoader.stop();
      }

      this.bannerList = this.bannerList.map((banner) => {
        let list = banner;
        list['banner_dates'] = this.formatDate(banner.org_publish_date_time, banner.expected_end_date_time_formated)
        return list
      })
      if(!this.router.url.includes('/network-market')){
        const urlParts = this.router.url.split("/");
        const channelName = urlParts[1];
        const groupSlug = urlParts[2];
        if (groupSlug && this.commanService.activeGroupId) {
          this.bannerList = this.bannerList.filter(
            b => b.network_group_id === this.commanService.activeGroupId
          );
        } 
        // else {
        //   this.bannerList = this.bannerList.filter(
        //     b => b.channel_name === channelName
        //   );
        // }
      }
      // Final safety net - the upcoming/live merge above only recognizes a live entry as a
      // duplicate of an already-listed upcoming one when they share an id/parent_streams_id; if
      // the same underlying event carries a different id in each section (e.g. a live-session id
      // distinct from the event id), it slips past that check and both copies land here.
      this.bannerList = this.dedupeBanners(this.bannerList);
      this.dumarray = this.bannerList;
      // Apply any pre-set filters (e.g. the default 3-month date range) to the freshly-fetched
      // list — applyFilters() is otherwise only triggered by the fan interacting with a filter.
      this.applyFilters();
      // bannerList is now finalized for display - only past this point can an empty list be
      // trusted as "the API genuinely returned no events" rather than "still fetching".
      this.isLoadingEvent = false;
      this.eventsLoadError = response.data?.statusCode !== '200';
      // assending
      this.ngxLoader.stop();
      // descnding
      console.log(this.bannerList, "bannerList");
      setTimeout(() => {
        this.sortData({ name: 'Event Date (Ascending)', value: "latest" });
      }, 200);
      let category_list = this.bannerList.forEach
      //  this.bannerList.splice(0,1);
      this.eventsLoaded = false;
    }).catch(error => {
      console.log("banner list - error", error);
      this.isLoadingEvent = false;
      this.eventsLoadError = true;
      this.ngxLoader.stop();
      this.eventsLoaded = false;
    });
  }
  retryEvents() {
    this.getEvents();
  }
  formatDate(startDate, endDate) {
    let startMonth = moment.utc(startDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('MMM')
    let endMonth = moment.utc(endDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('MMM')
    // console.log(startMonth, endMonth)
    let formattedStartDate = moment.utc(startDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('D')
    let formattedEndDate = moment.utc(endDate, "YYYY-MM-DD HH:mm:ss").tz(this.timezoneVal).format('D')
    if (startMonth === endMonth && formattedStartDate == formattedEndDate) {
      return `${startMonth} ${formattedStartDate}`
    } else if (startMonth == endMonth && formattedStartDate != formattedEndDate) {
      return `${startMonth} ${formattedStartDate}-${formattedEndDate}`
    } else {
      return `${startMonth} ${formattedStartDate}- ${endMonth} ${formattedEndDate}`
    }

  }
  goToEventReg(event) {
    console.log(event, "goToEventReg");
    if (event.isEvent && event.slug) {
      const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
      (window as any).umami?.track(`Cicked on Event ${event.id} - ${userId}`);
      const u_payload = {
        actionType: "event",
        metaData: {
          title: `Cicked on Event ${event.id}`,
          eventId: event.id,
          eventName: event.stream_video_title,
          orgId: event.organization_id,
          timeStamp: new Date().toISOString()
         
        },
        organizationId: event.organization_id || null,
        networkGroupId: event.network_group_id || null,
        clickAction: "event-type",
      };
      this.commonSubscribeService.sendTriggeredEvent(u_payload);
      this.router.navigate([this.getEventBasePath(event) + `/event/${event.slug}`]);
    }
  }

  // Network pages take the network slug from the URL (an event's channel_name can be its group's
  // own channel), then the event's own group - never the group the fan is currently browsing.
  getEventBasePath(event: any): string {
    const network = this.router.url.includes('/network-market/')
      ? event.channel_name
      : this.router.url.split('?')[0].split('/')[1];
    if (this.router.url.includes('/network-market/')) {
      return event.group_slug ? `/${network}/${event.group_slug}` : `/${network}`;
    }
    // event.group_slug can be stale vs the network's current group slug (which
    // ChannelWebpageGuard validates against, else 404), so resolve the group by id first.
    const group = this.groupsList?.find((g: any) => event.network_group_id && g.id === event.network_group_id)
      || this.groupsList?.find((g: any) => event.group_slug && g.group_slug === event.group_slug);
    return group ? `/${network}/${group.group_slug}` : `/${network}`;
  }

  getButtonStyles(cat: any) {
  if (!this.settingsData) return {};
  return {
    'background-color': this.settingsData[cat.catOn ? 'event_button_bg_primary_color' : 'event_bg_secondary_color'],
    'color': this.settingsData[cat.catOn ? 'event_button_font_primary_color' : 'event_font_secondary_color'],
    'border': `3px solid ${this.settingsData[cat.catOn ? 'event_button_bg_primary_color' : 'event_font_secondary_color']}`
  };
}
  // goToStream() {
  //   // let device = this.commonSubscribeService.getMobileOperatingSystem();
  //   // this.commonSubscribeService.sendDeviceType(device);
  //   this.commanService.sendScreenStatus(false);
  //   // if(this.streamInfo && this.streamInfo.number_of_creators == 1)
  //   // if (!this.userSubscriptionInfo.hasOwnProperty('ticket_ids'))
  //   //   this.router.navigateByUrl(`stream/${this.userSubscriptionInfo.ticket_key}`);
  //   // else
  //   let key = this.route.snapshot.params.ticket_key ? this.route.snapshot.params.ticket_key : this.userSubscriptionInfo.ticket_key;
  //   if ((this.subEvents && this.subEvents.length > 1))
  //     this.router.navigate(['event/schedule/' + key]);
  //   else
  //     this.router.navigate(['/stream/' + key], { queryParams: { stage: this.subEvents[0].streamid } });
  //   // else
  //   //   this.router.navigateByUrl(`group-stream/${this.streamInfo.id}`);
  // }
  filterValue = "";
  categoryList = [];

  filterData(data, from?) {
    this.filterValue = data;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Filter ${data} Clicked - ${userId}`)
    const payload = {
      actionType: "event",
      metaData: {
        title: `Filter ${data} Clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
      networkGroupId: this.commanService.activeGroupId || null,
      clickAction: 'attribute-select'
    }
    this.commanService.sendTriggeredEvent(payload);
    this.applyFilters();
  }
  selectedCat = "";
  selectedCatIndex: any;
  catFilter(name, i) {
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Event ${name} Clicked - ${userId}`)
    const data = {
      actionType: "event",
      metaData: {
        title: `Event ${name} Clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
      networkGroupId: this.commanService.activeGroupId || null,
      clickAction: 'attribute-select'
    }
    this.commanService.sendTriggeredEvent(data);
    this.dumarray.forEach(banner => {
      if (banner.category_name == name) {
        if (!banner.catOn) {
          banner.catOn = true;
          this.categoryList[i].catOn = true;
          this.selectedCat = name;
          this.selectedCatIndex = i;
        }
        else {
          banner.catOn = false;
          this.categoryList[i].catOn = false;
          this.selectedCat = "";
          this.selectedCatIndex = '';
        }
      }
      else {
        banner.catOn = false;
        for (let ind = 0; ind < this.categoryList.length; ind++) {
          if (ind != i) {
            this.categoryList[ind].catOn = false;
          }
        }
      }
    })
    this.filterValue = ''
    this.sortEvent = {};
    this.sortValue = '';
    this.searchfil = '';
    this.applyFilters();
  }

  sortValue = ""
  sortEvent = {}
  sortData(event) {
    if (event) {
      this.sortEvent = event;
    }
    let data = event.value;
    this.sortValue = event.name;
    this.bannerList.forEach(dat => {
      console.log(dat, "dat")
    })
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Sort By ${data} Clicked - ${userId}`)
    const payload = {
      actionType: "event",
      metaData: {
        title: `Sort By ${data} Clicked`,
        timeStamp: new Date().toISOString()
      },
      organizationId: event.organization_id || null,
    }
    // this.commanService.sendTriggeredEvent(payload);
    if (data == "a-z") {
      this.bannerList = this.bannerList.sort((a, b) => a.stream_video_title.toLowerCase() > b.stream_video_title.toLowerCase() ? 1 : -1);
    }
    else if (data == 'z-a') {
      this.bannerList = this.bannerList.sort((a, b) => a.stream_video_title.toLowerCase() > b.stream_video_title.toLowerCase() ? -1 : 1);
    }
    else if (data == "latest") {
      this.bannerList = this.bannerList.sort((a, b) => this.orgPublishDateValue(a) - this.orgPublishDateValue(b))
    }
    else if (data == "oldest") {
      this.bannerList = this.bannerList.sort((a, b) => this.orgPublishDateValue(b) - this.orgPublishDateValue(a))
    }
  }
  EventSearch() {
    const cleanQuery = this.searchfil?.trim();
    if (!cleanQuery) return;
    const userId = this.userInfo?.user_first_name + ' ' + this.userInfo?.user_last_name;
    (window as any).umami?.track(`Searched in Events - "${cleanQuery}" - ${userId}`);
    const data = {
      actionType: "event",
      metaData: {
        title: `Searched in Events - ${cleanQuery}`,
        timeStamp: new Date().toISOString()
      },
      organizationId: this.commanService?.slugInfo?.organization_id || null,
      networkGroupId: this.commanService.activeGroupId || null,
      clickAction: 'search'

    }
    this.commanService.sendTriggeredEvent(data);
  }

  clearEventSearch() {
    this.searchfil = '';
  }

  ngOnDestroy() {
      this.settingsDataSubscription?.unsubscribe();
      this.performerInfoSubscription?.unsubscribe();
  }
  
}